export const Support = () => {
    
    return(
        <>
        <div id="partners" className="support-block">
            <h2 className="title-support">Supported by</h2>
            <div className="support">
                <div className="support-item move-right delay-1">
                    <img src="./img/support/DenovoAgency.png" alt="" />
                </div>
                <div className="support-item move-right delay-2">
                    <img src="./img/support/let-do-it.png" alt="" />
                </div>
                <div className="support-item move-right delay-3">
                    <img src="./img/support/pic-indian.png" alt="" />
                </div>
                <div className="support-item move-right delay-4">
                    <img src="./img/support/mon.png" alt="" />
                </div>
                <div className="support-item move-right delay-5">
                    <img src="./img/support/pic.png" alt="" />
                </div>
            </div>
        </div>
        </>
    );
}
